define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function asModal($cur) {
        var result = $.Deferred();
        var $mask = $('#modal-mask');
        if (!$mask.length) {
            $mask = $('<div id="modal-mask"></div>').appendTo('body');
        }
        $mask.css('zIndex', parseInt($cur.css('zIndex')) - 1);
        $mask.off('click').on('click', function () {
            $mask.hide();
            result.resolve();
        });
        $mask.show();
        return result;
    }
    exports.asModal = asModal;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/modal.js
// module id = 64
// module chunks = 0